(function () {
  const Core = window.RB.Core;
  const { buff } = window.RB.CardLib;
  const { ENEMY_ALONE_HERE, CONSCRIPT, MIGHT_BEATS_TOTAL_AT } = window.RB.CardLib.unl;

  window.RB.CardScripts = window.RB.CardScripts || {};
  Object.assign(window.RB.CardScripts, {
    "Angler Beast": { play: [{ op: "toHand", spec: { type: "unit", maxMight: 2 } }] },

    "Crescent Guardian": {
      addCosts: [
        {
          optional: true,
          cond: { k: "playedSpellThisTurn" },
          label: "Crescent Guardian",
          cost: { energy: 0, pips: 1, anyPower: 0, domains: ["chaos"] },
          entersReady: true,
        },
      ],
    },

    "Evershade Stalker": { play: [{ op: "discard", n: 1 }, { op: "draw", n: 1 }] },

    "Lunar Boon": { play: [{ op: "discard", n: 1 }, { op: "draw", n: 2 }] },

    "Megatusk": {
      abilities: [
        {
          cost: { energy: 0, pips: 0, anyPower: 0, domains: null },
          costXp: 3,
          label: "Megatusk",
          targets: [],
          program: [
            {
              op: "grant",
              spec: { type: "unit", friendly: true, here: true },
              keyword: "ganking",
              dur: "turn",
            },
          ],
        },
      ],
    },

    "Mister Root": {
      triggers: [
        {
          on: "move",
          optional: false,
          label: "When I move to a battlefield, gain 2 XP",
          targets: [],
          program: [{ op: "xp", n: 2 }],
          self: true,
          condSpec: { k: "evToBf" },
        },
      ],
    },

    "Vicious Snapjaws": {
      triggers: [
        {
          on: "dies",
          optional: false,
          label: "When another friendly unit dies, gain 1 XP",
          targets: [],
          program: [{ op: "xp", n: 1 }],
          friendlyUnit: true,
          condSpec: { k: "evSnapshotUnit" },
        },
      ],
    },

    "Bewitching Spirit": {
      play: [
        {
          op: "option", varKey: "bsWho", prompt: "Which player discards 1?",
          options: ["You discard 1", "Opponent discards 1"],
        },
        {
          op: "if", cond: { k: "varEq", key: "bsWho", value: 0 },
          then: [{ op: "discard", n: 1 }],
          else: [{ op: "discard", n: 1, who: "opponent" }],
        },
      ],
    },

    Isolate: {
      targets: [{
        bind: "t", spec: { type: "unit", enemy: true, atBf: true },
        prompt: "Move which enemy unit from a battlefield to its base?",
      }],
      play: [{
        op: "if",
        cond: {
          k: "count", cmp: "exactly", n: 2,
          spec: { type: "unit", enemy: true, sameLocAs: "t", ignoreUntargetable: true },
        },
        then: [{ op: "move", to: "$t", dest: "base" }, { op: "draw", n: 1 }],
        else: [{ op: "move", to: "$t", dest: "base" }],
      }],
    },

    "Star-Crossed": {
      targets: [
        {
          bind: "f", spec: { type: "unit", friendly: true },
          prompt: "Return which friendly unit to its owner's hand?",
        },
        {
          bind: "e", spec: { type: "unit", enemy: true },
          prompt: "Return which enemy unit to its owner's hand?",
        },
      ],
      play: [{ op: "toHand", to: "$f" }, { op: "toHand", to: "$e" }],
    },

    "Blast Cone": {
      play: [{
        op: "may", prompt: "Move an enemy unit?",
        then: [
          {
            op: "choose", bind: "_bc", spec: { type: "unit", enemy: true },
            prompt: "Move which enemy unit?",
          },
          { op: "move", to: "$_bc" },
        ],
      }],
      triggers: [{
        on: "move", optional: true, exhaustSelf: true,
        label: "exhaust me to Stun the enemy unit you moved",
        condSpec: { k: "and", conds: [{ k: "evYou" }, { k: "evEnemy" }, { k: "selfReady" }] },
        program: [{ op: "exhaust", to: "source" }, { op: "stun", to: "$ev" }],
      }],
    },

    "Existential Dread": {
      targets: [{
        bind: "t", spec: { type: "unit", enemy: true, attacking: true },
        prompt: "Stun which attacking enemy unit?",
      }],
      play: [{
        op: "if", cond: { k: "targetStunned", bind: "t" },
        then: [{ op: "toHand", to: "$t" }],
        else: [{ op: "stun", to: "$t" }],
      }],
      repeatCosts: [{ cost: { energy: 2, pips: 0, anyPower: 0, domains: null } }],
    },

    "Insightful Investigator": {
      addCosts: [{
        optional: true, cond: null, label: "Insightful Investigator", costXp: 2,
        then: [
          {
            op: "revealHandPick", who: "opponent", bind: "_ii",
            prompt: "They reveal their hand - choose the card they discard",
          },
          { op: "discard", to: "$_ii" },
          { op: "draw", n: 1, who: "opponent" },
        ],
      }],
    },

    "Scryer's Bloom": {
      entersExhausted: true,
      abilities: [{
        label: "Kill this, 1 Energy, exhaust: Predict 2, then draw 1. Gain 1 XP",
        cost: { energy: 1, pips: 0, anyPower: 0, domains: null },
        exhausts: true, killSelf: true, targets: [],
        program: [{ op: "predict", n: 2 }, { op: "draw", n: 1 }, { op: "xp", n: 1 }],
      }],
    },

    "Sinister Poro": {
      triggers: [{
        on: "attack", self: true, optional: true,
        label: "pay 1 Energy to send an enemy unit here to its base",
        program: [
          {
            op: "payCost", varKey: "spPay", skipOnFail: 2,
            cost: { energy: 1, pips: 0, anyPower: 0, domains: null },
          },
          {
            op: "choose", bind: "_sp", spec: { type: "unit", enemy: true, here: true },
            prompt: "Move which enemy unit here to its base?",
          },
          { op: "move", to: "$_sp", dest: "base" },
        ],
      }],
    },

    Conscription: {
      addCosts: [{
        optional: true, cond: null, label: "Conscription", costXp: 5,
        then: CONSCRIPT(
          { type: "unit", enemy: true, atBf: true },
          "Take control of which enemy unit at a battlefield?"
        ),
        otherwise: CONSCRIPT(
          { type: "unit", enemy: true, atBf: true, maxMight: 3 },
          "Take control of which enemy unit at a battlefield with 3 Might or less?"
        ),
      }],
    },

    "Evelynn, Entrancing": {
      play: [{
        op: "if", cond: { k: "and", conds: [{ k: "fromFacedown" }, { k: "myTurn" }] },
        then: [{
          op: "may", prompt: "Move an enemy unit at a different location to my battlefield?",
          then: [
            {
              op: "choose", bind: "_ev", spec: { type: "unit", enemy: true, otherLoc: true },
              prompt: "Move which enemy unit to my battlefield?",
            },
            { op: "move", to: "$_ev", destRef: "source" },
          ],
        }],
      }],
    },

    "Heedless Resurrection": {
      addCosts: [{
        optional: false, cond: null, label: "Heedless Resurrection",
        costKill: { type: "unit" },
      }],
      targets: [{
        bind: "t",
        spec: {
          zone: "trash", type: "unit", friendly: true,
          maxEnergyVarLE: "killCostEnergy", maxPipsVarLE: "killCostPower",
        },
        prompt: "Play which unit from your trash, ignoring its cost?",
      }],
      play: [{ op: "playFrom", to: "$t", waive: "all" }],
    },

    "Kha'Zix, Mutating Horror": {
      triggers: [
        {
          on: "attack", self: true, label: "attack with an enemy alone here: +2 Might, 2 XP",
          condSpec: ENEMY_ALONE_HERE,
          program: [buff("source", 2), { op: "xp", n: 2 }],
        },
        {
          on: "defend", self: true, label: "defend with an enemy alone here: +2 Might, 2 XP",
          condSpec: ENEMY_ALONE_HERE,
          program: [buff("source", 2), { op: "xp", n: 2 }],
        },
      ],
    },

    "Maduli the Gatekeeper": {
      noReady: true,
      abilities: [{
        cost: { energy: 0, pips: 1, anyPower: 0, domains: ["chaos"] },
        label: "Move me to an occupied enemy battlefield I outweigh",
        targets: [],
        program: [
          {
            op: "choose", bind: "_md", min: 0,
            spec: { type: "unit", enemy: true, atBf: true, ignoreUntargetable: true },
            prompt: "Move me to the battlefield of which enemy unit?",
          },
          {
            op: "if",
            cond: {
              k: "and",
              conds: [{ k: "targetsChosen", bind: "_md" }, MIGHT_BEATS_TOTAL_AT("_md")],
            },
            then: [{ op: "move", to: "source", destRef: "$_md" }],
          },
        ],
      }],
    },

    "Pyke, Returned": {
      triggers: [{
        on: "dies", oncePerTurn: true,
        label: "an enemy unit died while I hold a battlefield: Gold token",
        condSpec: {
          k: "and",
          conds: [{ k: "evSnapshotUnit" }, { k: "evSnapshotEnemy" }, { k: "selfAtBf" }],
        },
        program: [{ op: "token", name: "Gold", exhausted: true }],
      }],
    },

    "Baron Nashor": {
      selfUntargetable: true,
      auraMightSpecs: [{ n: 2, excludeSelf: true }],
      addsBfToken: { card: "Baron Pit", enterThere: true },
    },

    "Diana, No Longer Human": {
      triggers: [{
        on: "finalizedCard", label: "you played a spell: +2 Might",
        condSpec: { k: "and", conds: [{ k: "evYou" }, { k: "evType", type: "spell" }] },
        program: [buff("source", 2)],
      }],
    },

    "Vex, Apathetic": {
      triggers: [{
        on: "played", label: "Stun the unit an opponent played",
        condSpec: {
          k: "and",
          conds: [{ k: "evEnemy" }, { k: "evType", type: "unit" }, { k: "selfAtBf" }],
        },
        program: [
          { op: "stun", to: "$ev" },
          {
            op: "grant", to: "$ev", noMove: true, dur: "turn",
            noMoveReason: "Vex, Apathetic stopped that unit from moving this turn",
          },
        ],
      }],
    },

    "Syndra, Transcendent": {
      auraRepeatCosts: [{
        who: "friendly", what: { type: "spell" },
        cond: { k: "showdownHere" },
        cost: { energy: 2, pips: 1, anyPower: 0, domains: ["chaos"] },
      }],
    },

    "The List": {
      play: [{ op: "nameChoice", kind: "tag", prompt: "Name a tag" }],
      abilities: [{
        label: "Give a unit with the named tag -2 Might this turn",
        cost: { energy: 0, pips: 0, anyPower: 0 },
        exhausts: true,
        targets: [{
          bind: "tl", spec: { type: "unit", namedTag: true },
          prompt: "Give which unit with the named tag -2 Might?",
        }],
        program: [{ op: "grant", to: "$tl", might: -2, floor: 0, dur: "turn" }],
      }],
    },

    "Bone Skewer": {
      targets: [{ bind: "bs", spec: { zone: "battlefield" }, prompt: "Choose a battlefield" }],
      play: [
        { op: "setVarLoc", from: "$bs", varKey: "bsLoc" },
        {
          op: "revealHandPick", who: "opponent", type: "unit", bind: "bu", optional: true,
          prompt: "Choose a unit from that hand (or none)",
        },
        { op: "playFrom", to: "$bu", byOwner: true, waive: "all", locVar: "bsLoc" },
        {
          op: "delayed", on: "played", forEachBind: "bu", carry: ["bu"],
          label: "Bone Skewer: Stun it",
          program: [{ op: "stun", to: "$bu" }],
        },
      ],
    },

    "Cursed Sarcophagus": {
      play: [{ op: "banishFromTrash", type: "unit" }],
      abilities: [{
        label: "Play a unit banished with this",
        cost: { energy: 0, pips: 0, anyPower: 0 },
        exhausts: true,
        program: [{ op: "playBanishedWithPick", type: "unit", prompt: "Play which unit banished with this?" }],
      }],
    },

    "Walking Roost": {
      play: [{ op: "token", name: "Bird", n: 1, who: "opponent" }],
    },

    "Abandon": {
      targets: [{
        bind: "t", spec: { zone: "chain", type: "spell", counterable: true },
        prompt: "Counter which spell?",
      }],
      play: [
        { op: "counter", to: "$t", dest: "hand" },
        { op: "predict", n: 1 },
      ],
    },
  });
})();
